import './activityIndicator.css';

const ActivityIndicator = () => {
    return <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
}

export default ActivityIndicator;